import React from "react";
import UserForm from "./UserForm";

export default function UserAdd() {
  return <UserForm mode="add" />;
}
